<template>
    <v-card outlined>
        <v-toolbar flat>
            <v-toolbar-title class="text-uppercase body-1 font-weight-medium">Accounts</v-toolbar-title>
            <v-divider class="mx-4" inset vertical></v-divider>

            <div class="flex-grow-1"></div>

            <!-- search ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-col cols="3" sm="3" md="3">
              <v-text-field
                  v-model="search"
                  append-icon="search"
                  label="Search"
                  single-line
                  hide-details
              ></v-text-field>
            </v-col>
        </v-toolbar>

        <!-- content -->
        <v-data-table
            :headers="headers"
            :items="items"
            :search="search"
            :sort-by="['account_id']"
            :sort-desc="[false]"
            :items-per-page="15"
            item-key="account_od"
            multi-sort
            dense
            >

            <!-- header ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template v-slot:top>
              <p>&nbsp;</p>
            </template>

            <!-- no-data ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <template slot="no-data" class="text-left">
                <span class="subheading text-left">
                    <v-icon color="orange">warning</v-icon>
                    No accounts found.
                </span>
            </template>

            <template v-slot:item.enabled="{ item }">
                <v-chip v-if="item.enabled == true" small color="green" dark>YES</v-chip>
                <v-chip v-else                      small color="red" dark>NO</v-chip>
            </template>
            <template v-slot:item.roles="{ item }">
                <template v-for="(role,r) in item.roles">
                  <br>{{ role }}
                </template>
            </template>

           </v-data-table>

    </v-card>
</template>

<script>
import AccountService from '@/services/AccountService'
export default {
  name: 'ListAccounts',
  data() {
    return {
        items: [],
        search: '',
        headers: [
          {
            text: 'ID',
            align: 'center',
            sortable: true,
            value: 'account_id'
          },
          {
            text: 'USERNAME',
            align: 'left',
            sortable: true,
            value: 'username'
          },
          {
            text: 'ENABLED',
            align: 'center',
            sortable: true,
            value: 'enabled'
          },
          {
            text: 'ROLES',
            align: 'left',
            sortable: false,
            value: 'roles'
          }
        ]
    }
  },
  created() {
    AccountService.getAccounts()
      .then(response => {
        this.items = response.data
        this.$toast.info("Loaded " + this.items.length + " accounts.")
      })
      .catch(error => { this.$toast.error("Error loading account data. " + error.message) })
  }
}
</script>
